<section class="avd-component-examples-page">
    @switch (componentName) {
        @case ('button') {
            <avd-button-examples></avd-button-examples>
        }
        @case ('card') {
            <avd-card-examples></avd-card-examples>
        }
        @case ('checkbox') {
            <avd-checkbox-examples></avd-checkbox-examples>
        }
        @case ('chips') {
            <avd-chip-examples></avd-chip-examples>
        }
        @case ('data-table') {
            <avd-table-examples></avd-table-examples>
        }
        @case ('dialog') {
            <avd-dialog-examples></avd-dialog-examples>
        }
        @case ('fab') {
            <avd-fab-examples></avd-fab-examples>
        }
        @case ('tree-view') {
            <avd-tree-examples></avd-tree-examples>
        }
        @case ('icon-button') {
            <avd-icon-button-examples></avd-icon-button-examples>
        }
        @case ('list') {
            <avd-list-examples></avd-list-examples>
        }
        @case ('app-navigation') {
            <avd-navrail-examples></avd-navrail-examples>
        }
        @case ('app-bar') {
            <avd-app-bar-examples></avd-app-bar-examples>
        }
        @case ('menu') {
            <avd-menu-examples></avd-menu-examples>
        }
        @case ('notification') {
            <avd-notification-examples></avd-notification-examples>
        }
        @case ('progress-indicators') {
            <avd-progress-indicators-examples></avd-progress-indicators-examples>
        }
        @case ('radio-button') {
            <avd-radio-examples></avd-radio-examples>
        }
        @case ('tooltip') {
            <avd-tooltip-examples></avd-tooltip-examples>
        }
        @case ('text-field') {
            <avd-text-field-examples></avd-text-field-examples>
        }
        @case ('side-sheet') {
            <avd-side-sheet-examples></avd-side-sheet-examples>
        }
        @case ('single-select') {
            <avd-select-examples></avd-select-examples>
        }
        @case ('snackbar') {
            <avd-snackbar-examples></avd-snackbar-examples>
        }
        @case ('tabs') {
            <avd-tabs-examples></avd-tabs-examples>
        }
        @case ('stepper') {
            <avd-stepper-examples></avd-stepper-examples>
        }
        @case ('switch') {
            <avd-switch-examples></avd-switch-examples>
        }
        @default {
            <p>
                No examples found for <strong>{{ componentName }}</strong
                >.
            </p>
        }
    }
</section>
